module.exports = __webpack_public_path__ + "static/media/happy_easter_map.01b1486b.svg";